<template>
  <div class="ThreeModel-css">
    <div :class="['explode', isShowBoom ? 'active' : '']" @click.stop="isShowBoom = !isShowBoom">
      <img :src="require(isShowBoom ? '@/assets/img/explode2.svg' : '@/assets/img/explode.svg')" alt="" />
      <span>爆炸</span>
      <div style="width: 60%">
        <v-slider v-show="isShowBoom" v-model="sliderValue" hide-details thumb-label="" min="0" max="100"></v-slider>
      </div>
    </div>
    <div id="canvas-box" class="canvas">
      <!-- <canvas id="canvas" ref="canvas"></canvas> -->
    </div>
    <div id="canvas-views" class="views">
      <div class="views-box">
        <img :src="require('@/assets/img/empty.svg')" alt="" />
        <span>视图</span>
        <ul>
          <li></li>
          <li><img :src="require('@/assets/img/top.svg')" @click="setPosition('top')" alt="" /></li>
          <li></li>
          <li></li>
          <li><img :src="require('@/assets/img/behind.svg')" @click="setPosition('behind')" alt="" /></li>

          <li><img :src="require('@/assets/img/left.svg')" @click="setPosition('left')" alt="" /></li>
          <li><img :src="require('@/assets/img/front.svg')" @click="setPosition('front')" alt="" /></li>
          <li><img :src="require('@/assets/img/right.svg')" @click="setPosition('right')" alt="" /></li>
          <li></li>
          <li><img :src="require('@/assets/img/all.svg')" @click="setPosition('all')" alt="" /></li>

          <li></li>
          <li><img :src="require('@/assets/img/bottom.svg')" @click="setPosition('bottom')" alt="" /></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import tree from 'vue-giant-tree'
import modelSplit from './modelSplit'
import { Collapse } from '@/components'
import { ModelGltf } from 'vue-3d-model'
import { Pagination } from '@/components'
import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

let scene = null
let renderer = null
let camera = null
let controls = null

export default {
  name: 'ThreeModel',
  data() {
    return {
      // url: 'https://metastation.oss-cn-hangzhou.aliyuncs.com/gltf/%E6%89%8B%E5%8A%A8%E6%9C%BA%E6%9E%84%E6%94%AF%E6%9E%B6%E6%80%BB%E8%A3%85.gltf?name=110变电站#1',
      // url: 'https://metastation.oss-cn-hangzhou.aliyuncs.com/gltf/35kV%E5%BC%80%E5%85%B3%E6%9F%9C.gltf',
      // url: 'https://metastation.oss-cn-hangzhou.aliyuncs.com/gltf/110kV-Substation.gltf?name=110变电站#1',
      loadMap: {
        STLLoader,
        GLTFLoader
      },
      isShowBoom: false,
      loading: false,
      sliderValue: 0,
      scenes: [],
      scene: null
    }
  },
  props: {
    url: {
      default: '',
      type: String
    },
    sceneId: {
      default: '',
      type: String
    }
  },
  components: {
    tree,
    Collapse,
    ModelGltf,
    Pagination
  },
  methods: {
    setPosition(type) {
      let camera = camera
      switch (type) {
        case 'top':
          camera.position.x = 0
          camera.position.y = 300
          camera.position.z = 0
          break
        case 'bottom':
          camera.position.x = 0
          camera.position.y = -300
          camera.position.z = 0
          break
        case 'front':
          camera.position.x = 0
          camera.position.y = 0
          camera.position.z = 300
          break
        case 'behind':
          camera.position.x = 0
          camera.position.y = 0
          camera.position.z = -300
          break
        case 'right':
          camera.position.x = 300
          camera.position.y = 0
          camera.position.z = 0
          break
        case 'left':
          camera.position.x = -300
          camera.position.y = 0
          camera.position.z = 0
          // camera.quaternion.set(-0.4, -0.5, -0.5, -0.4);
          break
        case 'all':
          camera.position.x = 200
          camera.position.y = 100
          camera.position.z = 200
          // camera.quaternion.set(-0.4, -0.5, -0.5, -0.4);
          break
      }
    },
    getImage() {
      let canvas = renderer.domElement

      renderer.render(scene, camera)

      return canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
    },
    ztreeOnCheck(ztreeObj, treeId, treeNode) {
      let list = this.ztreeObj.getCheckedNodes()
      let idList = list.map((v) => v.id)
      function setModel(list) {
        list.forEach((v) => {
          v.visible = idList.includes(v.id)
          if (v.children && v.children.length !== 0) {
            setModel(v.children)
          }
        })
      }
      setModel(this.scenes)
    },
    initThree() {
      let width = document.getElementById('canvas-box').clientWidth
      let height = document.getElementById('canvas-box').clientHeight
      return {
        width,
        height
      }
    },
    render() {
      let position = camera.position
      this.point.position.set(position.x, position.y, position.z) //点光源位置
      renderer.render(scene, camera) //执行渲染操作
      let map = this.initThree()
      renderer.setSize(map.width, map.height)
      this.splitMap && this.splitMap.update()
      controls && controls.update()
      requestAnimationFrame(this.render)
    },
    init() {
      renderer = null
      camera = null
      controls = null
      scene = new THREE.Scene()
      // /**
      //  * 相机设置
      //  */
      let sizeMap = this.initThree()
      let width = sizeMap.width //窗口宽度
      let height = sizeMap.height //窗口高度
      let k = width / height //窗口宽高比
      let s = 500 //三维场景显示范围控制系数，系数越大，显示的范围越大
      // //创建相机对象
      camera = new THREE.OrthographicCamera(-s * k, s * k, s, -s, 1, 2000)
      camera.position.set(200, 100, 200) //设置相机位置
      camera.lookAt(scene.position) //设置相机方向(指向的场景对象)
      // /**
      //  * 创建渲染器对象
      //  */
      renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      })
      renderer.setPixelRatio(window.devicePixelRatio)
      renderer.setSize(width, height) //设置渲染区域尺寸
      renderer.setClearColor(0x35415e, 1) //设置背景颜色
      document.getElementById('canvas-box').appendChild(renderer.domElement)
      //执行渲染操作   指定场景、相机作为参数
      renderer.render(scene, camera)

      let point = new THREE.PointLight(0xc5c5c5)
      this.point = point
      point.position.set(0, 0, 0) //点光源位置
      scene.add(point) //点光源添加到场景中

      this.render()

      this.load()
    },
    load() {
      this.loadScenes('GLTFLoader', this.url)
    },
    setId(list) {
      let l = []
      let str = this.sceneId + '.1'
      let level = 0
      function setId(list, str, level) {
        list.forEach((v, i) => {
          v.uuuid = `${str}.${i}`
          v.level = level
          if (v.children && v.children.length !== 0) {
            setId(v.children, v.uuuid, level + 1)
          }
        })
      }
      setId(list, str, level)
    },
    getCenter() {
      if (!this.model) return
      let box2 = new THREE.Box3().expandByObject(this.model)
      let maxLength = box2.max.clone().distanceTo(box2.min)
      let center2 = box2.getCenter(new THREE.Vector3())
      console.log(center2, 'centercentercentercentercentercentercentercenter')
    },
    clearGroup(group) {
      const clearCache = (item) => {
        item.geometry.dispose()
        item.material.dispose()
      }
      const removeObj = (obj) => {
        let arr = obj.children.filter((x) => x)
        arr.forEach((item) => {
          if (item.children.length) {
            removeObj(item)
          } else {
            clearCache(item)
            item.clear()
          }
        })
        obj.clear()
        arr = null
      }
      removeObj(group)
    },
    loadScenes(load, url) {
      let l = new this.loadMap[load]()
      this.loading = true
      l.load(this.url, (res) => {
        res.scene.traverse(function (node) {
          if (node.material) {
            node.material.side = THREE.DoubleSide
          }
        })
        console.log(res.scenes, 'res', res)
        this.setId(res.scenes)
        this.$emit('getTree', res.scenes, this.url)

        this.scenes = res.scenes
        this.model = res.scene

        const boxHelper = new THREE.BoxHelper(this.model)
        boxHelper.geometry.computeBoundingBox()
        const box = boxHelper.geometry.boundingBox
        const maxDiameter = Math.max(box.max.x - box.min.x, box.max.y - box.min.y, box.max.z - box.min.z)
        const scaleValue = (camera.position.z / maxDiameter) * 2
        this.model.scale.set(scaleValue, scaleValue, scaleValue)
        /**
         * 包围盒全自动计算：模型整体居中
         */
        this.group && this.clearGroup(this.group)
        this.group = new THREE.Group()
        this.group.add(res.scene)
        let box3 = new THREE.Box3()
        // 计算层级模型this.group的包围盒
        // 模型this.group是加载一个三维模型返回的对象，包含多个网格模型
        box3.expandByObject(this.group)
        // 计算一个层级模型对应包围盒的几何体中心在世界坐标中的位置
        let center = new THREE.Vector3()
        box3.getCenter(center)

        // 重新设置模型的位置，使之居中。
        this.group.position.x = this.group.position.x - center.x
        this.group.position.y = this.group.position.y - center.y
        this.group.position.z = this.group.position.z - center.z
        scene.add(this.group)
        this.splitMap = new modelSplit()
        this.splitMap.setSplitModel(this.model)
        this.loading = false
        // this.clock = new THREE.Clock();
        controls = new OrbitControls(camera, renderer.domElement)
        controls.autoRotate = false
        // array[ i ].call undefined问题解决
        controls.domElement.addEventListener('change', renderer)
        controls.dampingFactor = 1
        controls.minDistance = 1
        controls.maxDistance = 1000000
        controls.rotateSpeed = 1
        controls.zoomSpeed = 2
        controls.minZoom = -Infinity
        controls.screenSpacePaning = true
        
        //获取在射线上的接触点
        let mouse = new THREE.Vector2()
        let raycaster = new THREE.Raycaster()
        let onmodelclick = (event) => {
          if (!event.path) {
            let target = event.target
            event.path = []
            while (target.parentNode !== null) {
              event.path.push(target)
              target = target.parentNode
            }
            // 最后补上document和window
            event.path.push(document, window)
          }
          let mainCanvas = event.path[0]
          let left = mainCanvas.getBoundingClientRect().left
          let top = mainCanvas.getBoundingClientRect().top
          mouse.x = ((event.clientX - left) / this.initThree().width) * 2 - 1
          mouse.y = -((event.clientY - top) / this.initThree().height) * 2 + 1

          raycaster.setFromCamera(mouse, camera)
          const intersects = raycaster.intersectObjects(scene.children)
          this.setOldColor()
          console.log(intersects, 'intersects[0]intersects[0]intersects[0]intersects[0]')
          if (intersects[0]) {
            this.setColor(intersects[0], 1)
          }
        }
        document.getElementById('canvas-box').onclick = onmodelclick
      })
    },
    setColor(map, type) {
      console.log(map, 'intersects[0]intersects[0]intersects[0]intersects[0]')
      if (!map.object) {
        this.setOldColor()
        return
      }
      if (!type) {
        this.setOldColor()
    
        map.object.traverse((v) => {
          if (v.type === 'Mesh') {
            v.material = new THREE.MeshLambertMaterial(v.material)
            v.material.oldColor = new THREE.Color(v.material.color)
            v.material.color.copy(new THREE.Color(0x00ffdc))
          }
        })
        return
      }
      map.object.material = new THREE.MeshLambertMaterial(map.object.material)
      map.object.material.oldColor = new THREE.Color(map.object.material.color)
      map.object.material.color.copy(new THREE.Color(0x00ffdc))
      type && this.$emit('modelClick', map.object)
    },
    setTranslate() {
      let scal = 1
      let offsetX = ''
      let offsetY = ''
      let ismove = false
      renderer.domElement.addEventListener('mousedown', (ev) => {
        ismove = true
        offsetX = ev.offsetX
        offsetY = ev.offsetY
        console.log(ev)
      })
      renderer.domElement.addEventListener('mousemove', (ev) => {
        if (ismove) {
          let x = ev.offsetX - offsetX
          let y = ev.offsetY - offsetY
          let m = this.group.position
          let m2 = camera.position
          let changeX = m.x + x
          let changeY = m.y - y
          let changeX2 = m2.x + x
          let changeY2 = m2.y - y
          this.group.position.set(changeX, changeY, m.z)
          // camera.position.set(changeX2, changeY2, m2.z);
          offsetX = ev.offsetX
          offsetY = ev.offsetY
          console.log(ev)
        }
      })
      renderer.domElement.addEventListener('mouseup', (ev) => {
        ismove = false
        console.log(ev)
      })
    },
    setScale() {
      let scal = 1
      renderer.domElement.addEventListener(
        'wheel',
        (ev) => {
          console.log(this.group)
          let scale = this.group.scale.x
          let down = true // 定义一个标志，当滚轮向下滚时，执行一些操作
          down = ev.wheelDelta ? ev.wheelDelta < 0 : ev.detail > 0
          if (down) {
            console.log('鼠标滚轮向上缩小++++++++++')
            if (scale === 0.01) {
              scale = 0.01
              return
            } else {
              scale = (parseFloat(scale) - scale / 10).toFixed(2)
            }
            console.log('缩小系数: ' + scale)
          } else {
            console.log('鼠标滚轮向下放大---------')
            scale = (parseFloat(scale) + scale / 10).toFixed(2)
            console.log('放大系数: ' + scale)
          }
          this.group.scale.set(scale, scale, scale)
        },
        { passive: false }
      )
    },
    setOldColor() {
      function setModel(list) {
        list.forEach((v) => {
          if (v.material) {
            v.material.color.copy(v.material.oldColor || v.material.color)
          }
          if (v.children && v.children.length !== 0) {
            setModel(v.children)
          }
        })
      }
      setModel(this.scenes)
    },
    setScene() {
      scene.add(this.model)
    },
  },
  mounted() {
    this.init()
  },
  watch: {
    sliderValue(val) {
      this.splitMap && this.splitMap.setValue(val / 100)
    }
  },
  beforeDestroy() {
    scene.clear()
    renderer.dispose()
    renderer.forceContextLoss()
    renderer.content = null
    const gl = renderer.domElement.getContext('webgl')
    gl && gl.getExtension('WEBGL_lose_context').loseContext()
    scene = null
    renderer = null
    camera = null
    controls = null
  }
}
</script>

<style lang="css" scoped>
.ThreeModel-css {
  height: 100%;
  position: relative;
}

.ThreeModel-css .explode {
  padding: 0 10px;
  cursor: pointer;
  position: absolute;
  left: 30px;
  top: 5px;
  display: flex;
  width: 50%;
}

.explode.active {
  background: #f0f6ff;
  width: 80%;
}

.ThreeModel-css .explode img {
  width: 20px;
  height: 30px;
}

.ThreeModel-css .explode span {
  margin-left: 10px;
  line-height: 30px;
  color: #fff;
}

.ThreeModel-css .views {
  position: absolute;
  left: 30px;
  bottom: 20px;
}

.ThreeModel-css .views .views-box:hover>ul {
  display: flex;
}

.ThreeModel-css .views .views-box {
  background: rgba(0, 0, 0, 0.3);
  padding: 5px 10px;
}

.ThreeModel-css .views ul {
  display: none;
  list-style: none;
  width: 160px;
  height: 120px;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: -134px;
  left: 0;
  flex-wrap: wrap;
  padding: 20px;
  border-radius: 5px;
}

.ThreeModel-css .views ul li {
  width: 20%;
  height: 30px;
}

.ThreeModel-css .views img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.ThreeModel-css .views .views-box>span {
  margin-left: 10px;
  line-height: 20px;
  color: #fff;
}

.explode.active img {
  color: #333;
}

.explode.active span {
  color: #333;
}

.canvas-box {
  height: 100%;
}

.canvas-box canvas {
  height: 100%;
}

.el-slider {
  width: 500px;
  position: absolute;
  left: 0%;
  top: 30px;
}
</style>
